 


import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute.js';

const hrRoutes: RouteObject[] = [
  // Home
  {
    path: 'HR/HomePage',
    lazy: lazyRoute(() => import('../../pages/HR/DashboardMain/HrDashBoard.jsx'))
  },

  // Settings
  {
    path: 'HR/settings/*',
    children: [
      { path: 'Job', lazy: lazyRoute(() => import('../../pages/HR/settings/Jobs/Job.jsx')) },
      { path: 'Job/:id/Edit', lazy: lazyRoute(() => import('../../pages/HR/settings/Jobs/EditJob.jsx')) },

      { path: 'JobGrade', lazy: lazyRoute(() => import('../../pages/HR/settings/JobGrades/JobGrades.jsx')) },
      { path: 'JobGrade/:id/Edit', lazy: lazyRoute(() => import('../../pages/HR/settings/JobGrades/EditJobGrade.jsx')) },

      { path: 'Location', lazy: lazyRoute(() => import('../../pages/HR/settings/Location/Location.jsx')) },
      {
        path: 'Location/:id/Edit',
        lazy: lazyRoute(() => import('../../pages/HR/settings/Location/EditLocation/EditLocation.jsx'))
      },

      { path: 'Position', lazy: lazyRoute(() => import('../../pages/HR/settings/position/position.jsx')) },
      { path: 'Position/:id/Edit', lazy: lazyRoute(() => import('../../pages/HR/settings/position/EditPosition.jsx')) },

      { path: 'StaffGroup', lazy: lazyRoute(() => import('../../pages/HR/settings/GroupEmployees/GroupEmployees.jsx')) },
      {
        path: 'StaffGroup/:id/Edit',
        lazy: lazyRoute(() => import('../../pages/HR/settings/GroupEmployees/EditGroupEmployees.jsx'))
      }
    ]
  },

  // Employees
  {
    path: 'HR/Employees/*',
    children: [
      // نفس سلوكك السابق: أي شيء تحت HR/Employees يروح على Employees
      { path: '*', lazy: lazyRoute(() => import('../../pages/HR/Employees/HR-PERSON/Index/Index.jsx')) },

      { path: ':id/Edit', lazy: lazyRoute(() => import('../../pages/HR/Employees/HR-PERSON/Edit/UpdatePerson.jsx')) },
      { path: ':id/Assignments', lazy: lazyRoute(() => import('../../pages/HR/Employees/Assignment/Assignment.jsx')) },

      {
        path: 'AbsencesAndVacations/:personId',
        lazy: lazyRoute(() => import('../../pages/HR/Employees/AbsencesAndVacations/index'))
      },

      {
        path: 'AttendanceAdjustment/:personId',
        lazy: lazyRoute(() => import('../../pages/HR/Employees/AttendanceAdjustment/AttendanceAdjustment.js'))
      },

      { path: 'EndOfService/:personId', lazy: lazyRoute(() => import('../../pages/HR/Employees/EndOfService/EndOfService.js')) },
      { path: 'Contracts/:personId', lazy: lazyRoute(() => import('../../pages/HR/Employees/Contracts/Index.js')) },

      {
        path: ':PersonId/ExtraRecordFormPerson',
        lazy: lazyRoute(() => import('../../pages/HR/Employees/HR-PERSON/ExtraRecord/ExtraRecordFormPerson.jsx'))
      }
    ]
  },

  // Organization / Departments
  {
    path: 'HR/*',
    children: [
      { path: 'Organizations', lazy: lazyRoute(() => import('../../pages/HR/Organizations/index')) },
      { path: 'Departments', lazy: lazyRoute(() => import('../../pages/HR/Departments/Departments.jsx')) },
      {
        path: 'OrganizationStructure',
        lazy: lazyRoute(() => import('../../pages/HR/Departments/Structure2/OrganizationStructure2.jsx'))
      }
    ]
  },

  // Delegation
  {
    path: 'HR/Delegation',
    lazy: lazyRoute(() => import('../../pages/HR/Delegation/Delegation.js'))
  },

  // Reports
  {
    path: 'HR/Reports/*',
    children: [
      { path: '*', lazy: lazyRoute(() => import('../../pages/HR/HRReports/HRReports.js')) },
      {
        path: ':ReportId/ReportsBuilder',
        lazy: lazyRoute(() => import('../../pages/NTX/Reports/ReportsAllByModule/Reports/ReportsBuilder/ReportsBuilder.js'))
      }
    ]
  },

  // HR Dashboard builder
  {
    path: 'HrDashboard/*',
    children: [
      { path: '*', lazy: lazyRoute(() => import('../../pages/HR/DashboardHR/DashboardHR.js')) },
      {
        path: ':dashboardId/BuilderDashboard',
        lazy: lazyRoute(() => import('../../pages/NTX/DashboardManagament/BuilderDashboard/BuilderDashboard.jsx'))
      }
    ]
  }
];

export default hrRoutes;
